import PropTypes from 'prop-types';
import { BsCheckCircle, BsClock, BsEnvelope } from 'react-icons/bs';

import Card from '#globalComponents/Card/Card';

import { useCampaignKPIs } from '../../../models/emailCampaigns/queries';

const KPICard = ({ icon: Icon, label, value, bgColor, iconColor }) => (
	<Card>
		<div className="flex items-center gap-3">
			<div className={`w-9 h-9 rounded-card grid place-items-center ${bgColor}`}>
				<Icon className={`h-4 w-4 ${iconColor}`} />
			</div>
			<div>
				<p className="text-[11px] font-medium text-bgBase-800 uppercase tracking-wide">{label}</p>
				<p className="text-lg font-bold text-text leading-tight">{value}</p>
			</div>
		</div>
	</Card>
);

KPICard.propTypes = {
	icon: PropTypes.elementType.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	bgColor: PropTypes.string.isRequired,
	iconColor: PropTypes.string.isRequired,
};

const CampaignKPICards = () => {
	const { data: kpis, isLoading } = useCampaignKPIs();

	if (isLoading) {
		return (
			<div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
				{[...Array(3)].map((_, i) => (
					<Card key={i} className="animate-pulse">
						<div className="flex items-center gap-3">
							<div className="w-9 h-9 bg-bgBase-400 rounded-card" />
							<div className="flex-1">
								<div className="h-2.5 bg-bgBase-400 rounded w-14 mb-2" />
								<div className="h-5 bg-bgBase-400 rounded w-10" />
							</div>
						</div>
					</Card>
				))}
			</div>
		);
	}

	const kpiCards = [
		{
			icon: BsEnvelope,
			label: 'Gesendet',
			value: kpis?.sent?.toLocaleString('de-DE') || '0',
			bgColor: 'bg-primary-100',
			iconColor: 'text-primary-500',
		},
		{
			icon: BsCheckCircle,
			label: 'Zugestellt',
			value: kpis?.delivered?.toLocaleString('de-DE') || '0',
			bgColor: 'bg-success-200',
			iconColor: 'text-success-500',
		},
		{
			icon: BsClock,
			label: 'Ausstehend',
			value: kpis?.pending?.toLocaleString('de-DE') || '0',
			bgColor: 'bg-caution-200',
			iconColor: 'text-caution-500',
		},
	];

	return (
		<div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
			{kpiCards.map((card, index) => (
				<KPICard
					key={index}
					icon={card.icon}
					label={card.label}
					value={card.value}
					bgColor={card.bgColor}
					iconColor={card.iconColor}
				/>
			))}
		</div>
	);
};

export default CampaignKPICards;
